import React, { FC, Fragment, useState } from 'react';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { useIdentity } from '../../store/identyti/identity-context';
import { UserListToggle } from './UserListToggle';
import { getFormattedDate } from '../../utils/utilities';
import { ButtonComponent } from '../ButtonComponent';
import { ChangePasswordForm } from '../profileSettings/forms/ChangePasswordForm';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';

export const UserDetailsSecurity: FC = () => {
	const { t } = useTranslation();
	const { identityState: { usersList }} = useIdentity();
	const user = usersList[0];

	const [isChangePassModalOpen, setIsChangePassModalOpen] = useState(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	console.log('user---', user.email);

	const securityFields = [
		{
			key: 'auth',
			title: 'Two-factor authentication',
			value: user,
		},
		{
			key: 'lastLogin',
			title: 'Last login',
			value: user?.lastLogin,
		},
		{
			key: 'joinedDate',
			title: 'Joined date',
			value: user?.joinedDate,
		},
	];

	const getSecurityValue = (key, value): JSX.Element => {
		switch (key) {
			case 'auth':
				return <UserListToggle {...value}/>;
			case 'lastLogin':
				return (
					<>
						{
							value
								? (
									<>
										<div className="fs-6">
											{getFormattedDate(value, 'dd MMM, yyyy')}
										</div>
										<div className="fs-7">
											{getFormattedDate(value, 'hh:mm a')}
										</div>
									</>
								) : '-'
						}
					</>
				);
			case 'joinedDate':
				return (
					<>
						{
							value
								? (
									<div className="fs-6">
										{getFormattedDate(value, 'dd MMM, yyyy')}
									</div>
								) : '-'
						}
					</>
				);
		}
	};

	const getSecurityFields = (key, title, value): JSX.Element => {
		return (
			<div className="col-6 col-sm-4 col-md-3">
				<div className="text-muted fs-6 mb-2">{title}</div>
				{getSecurityValue(key, value)}
			</div>
		);
	};

	const onCloseModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

	const changePasswordSuccessModal = (): void => {
		setIsChangePassModalOpen(false);
		setModalState({
      isOpen: true,
      modalTitle: 'Reset password',
      content: (
        <div className="fs-6">
          Password was successfully changed!
        </div>
      ),
      confirmButtonText: t('PARTNERS.SUCCESS_BTN_NAME'),
      minHeight: 100,
      onConfirm: onCloseModal,
      onClose: onCloseModal
    });
	};

	const changePasswordErrorModal = (): void => {
		setIsChangePassModalOpen(false);
		setModalState({
      isOpen: true,
      modalTitle: 'Reset password',
      content: (
        <div className="fs-6">
          Failed changing password
        </div>
      ),
      confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
      minHeight: 100,
      onConfirm: () => {
        onCloseModal();
	      setIsChangePassModalOpen(true);
      },
      onClose: onCloseModal
    });
	};

	return (
		<>
			<SectionWrapper
				title={t('USER.USER_SECURITY')}
				sectionAdditionalClass="mb-5 min-height-200"
				isCardBody
			>
				<div className="row mb-10">
					{securityFields.map(({ key, title, value }) => (
						<Fragment key={key}>
							{getSecurityFields(key, title, value)}
						</Fragment>
					))}
				</div>

				<div className="separator" />

				<div className="fs-2 py-5 mb-3 border-bottom-separator">Reset password</div>
				<div className="text-muted fs-7 mb-3">To reset this user`s password, please be aware that the old password will be
					invalidated. Proceed with caution, as this action cannot be undone.
				</div>
				<ButtonComponent
					buttonName="Reset password"
					additionalClass="btn-sm"
					onButtonClick={(): void => setIsChangePassModalOpen(true)}
				/>
			</SectionWrapper>

			<ModalWindow
				{...modalState}
				onClose={onCloseModal}
			/>

			<ModalWindow
				isOpen={isChangePassModalOpen}
				modalTitle="Reset password"
				onClose={(): void => setIsChangePassModalOpen(false)}
				contentClassName="d-block"
				backdrop="static"
				minHeight={300}
				content={
					<ChangePasswordForm
						closeModal={(): void => setIsChangePassModalOpen(false)}
						onSuccess={changePasswordSuccessModal}
						onError={changePasswordErrorModal}
						userId={user?.id}
						userEmail={user?.email}
					/>
				}
			/>
		</>
	);
};
